import { SalesTab } from '@/features/sales/SalesTab';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/sales/sales')({
  validateSearch: z.object({
    from: z.string().optional(),
    to: z.string().optional(),
    channel_connection_id: z.string().optional(),
    label: z.string().optional(),
    method: z.string().optional(),
    status: z.string().optional(),
  }),
  component: SalesTab,
});
